// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { INITIAL_AMOUNT_OF_HISTORY_ROWS } = require('constants/contactCenter/cardsControlHistory');

// @helpers
const { getLanguage } = require('core/i18n').i18n;

const historyDataRequest = () => ({
    type: actionTypes.CARDS_CONTROL_HISTORY_QUERY_REQUEST
});

const historyDataSuccess = (panNumber, data, numActions, hasMore) => ({
    type: actionTypes.CARDS_CONTROL_HISTORY_QUERY_SUCCESS,
    payload: {
        panNumber,
        data,
        numActions,
        hasMore
    }
});

const historyDataFailure = (error) => ({
    type: actionTypes.CARDS_CONTROL_HISTORY_QUERY_FAILURE,
    payload: {
        error
    }
});


const getQueryResults = (panNumber, isFirstFetch = true) => (dispatch, getState) => {
    const immCardsControlHistory = getState().cardsControlHistory;
    const dateEnd = immCardsControlHistory.get('filterDateTo').format('YYYY-MM-DD');
    const dateStart = immCardsControlHistory.get('filterDateFrom').format('YYYY-MM-DD');
    const amountOfHistoryRows = immCardsControlHistory.get('amountOfHistoryRows');

    const numActions = isFirstFetch ? INITIAL_AMOUNT_OF_HISTORY_ROWS : amountOfHistoryRows + INITIAL_AMOUNT_OF_HISTORY_ROWS;

    const params = {
      dateEnd,
      dateStart,
      pan: panNumber,
      numActions,
      startIndex: 0,
    };

    const urlParams = {
        lang: getLanguage().toLowerCase()
    }

    dispatch(historyDataRequest());

    return APIPost({
        dispatch,
        endpoint: 'cardsControlHistory',
        params: {
            query: params,
            ...urlParams
        }
    }).then((response) => {
        dispatch(historyDataSuccess(panNumber, response, numActions, response.hasMore));
    }).catch((error) => {
        dispatch(historyDataFailure(error));
    });
}

const reset = () => {
    return {
        type: actionTypes.CARDS_CONTROL_HISTORY_RESET
    }
}

const setDateFrom = value => {
    return {
        type: actionTypes.CARDS_CONTROL_HISTORY_SET_DATE_FROM,
        payload: {
            value
        }
    }
}

const setDateTo = value => {
    return {
        type: actionTypes.CARDS_CONTROL_HISTORY_SET_DATE_TO,
        payload: {
            value
        }
    }
}

module.exports = {
    getQueryResults,
    reset,
    setDateFrom,
    setDateTo
}
